import { AdjustmentType } from "./additional.enum";

export enum AdjustmentReason {
  DOCUMENTATION_INVENTORY = 'DOCUMENTATION_INVENTORY',
  PUNCTUALITY = 'PUNCTUALITY',
  WRONG_DELIVERY = 'WRONG_DELIVERY',
  FUEL = 'FUEL',
  ADDITIONAL_SERVICES = 'ADDITIONAL_SERVICES',
  EXCESS_KILOMETERS = 'EXCESS_KILOMETERS',
  BEHAVIOR_APPEARANCE = 'BEHAVIOR_APPEARANCE',
  DAMAGES = 'DAMAGES',
  FINE = 'FINE',
  //BILLING = 'BILLING',
  OPERATIONS_PROCESS = 'OPERATIONS_PROCESS',
  FRAUD = 'FRAUD',
  DRIVER_RECOGNITION = 'DRIVER_RECOGNITION',
  UNASSIGNATION = 'UNASSIGNATION',
  OTHER = 'OTHER',
}

export const adjustmentReasonDescriptions: Record<AdjustmentReason, string> = {
  [AdjustmentReason.DOCUMENTATION_INVENTORY]: 'adjustmentReason.DOCUMENTATION_INVENTORY',
  [AdjustmentReason.PUNCTUALITY]: 'adjustmentReason.PUNCTUALITY',
  [AdjustmentReason.WRONG_DELIVERY]: 'adjustmentReason.WRONG_DELIVERY',
  [AdjustmentReason.FUEL]: 'adjustmentReason.FUEL',
  [AdjustmentReason.ADDITIONAL_SERVICES]: 'adjustmentReason.ADDITIONAL_SERVICES',
  [AdjustmentReason.EXCESS_KILOMETERS]: 'adjustmentReason.EXCESS_KILOMETERS',
  [AdjustmentReason.BEHAVIOR_APPEARANCE]: 'adjustmentReason.BEHAVIOR_APPEARANCE',
  [AdjustmentReason.DAMAGES]: 'adjustmentReason.DAMAGES',
  [AdjustmentReason.FINE]: 'adjustmentReason.FINE',
  //[AdjustmentReason.BILLING]: 'adjustmentReason.BILLING',
  [AdjustmentReason.OPERATIONS_PROCESS]: 'adjustmentReason.OPERATIONS_PROCESS',
  [AdjustmentReason.FRAUD]: 'adjustmentReason.FRAUD',
  [AdjustmentReason.DRIVER_RECOGNITION]: 'adjustmentReason.DRIVER_RECOGNITION',
  [AdjustmentReason.UNASSIGNATION]: 'adjustmentReason.UNASSIGNATION',
  [AdjustmentReason.OTHER]: 'adjustmentReason.OTHER',
};

export enum AdjustmentSubType {
  // Documentación / Inventario
  DOC_NOT_SENT = 'DOC_NOT_SENT',
  DOC_INCOMPLETE = 'DOC_INCOMPLETE',
  DOC_INVALID = 'DOC_INVALID',
  INVENTORY_INCOMPLETE = 'INVENTORY_INCOMPLETE',
  SIGNATURE_MISSING = 'SIGNATURE_MISSING',
  DOC_OTHER = 'DOC_OTHER',

  // Puntualidad
  PUNCTUALITY_DELAY = 'PUNCTUALITY_DELAY',

  // Entrega incorrecta / abandono
  WRONG_LOCATION = 'WRONG_LOCATION',
  PUBLIC_ROAD = 'PUBLIC_ROAD',
  WRONG_PERSON = 'WRONG_PERSON',
  UNAUTHORIZED_AREA = 'UNAUTHORIZED_AREA',
  DELIVERY_INSTRUCTIONS_IGNORED = 'DELIVERY_INSTRUCTIONS_IGNORED',
  EXTRA_DISTANCE = 'EXTRA_DISTANCE',
  WRONG_DELIVERY_OTHER = 'WRONG_DELIVERY_OTHER',

  // Combustible
  FUEL_LOW_LEVEL = 'FUEL_LOW_LEVEL',
  FUEL_NO_DASH_PHOTO = 'FUEL_NO_DASH_PHOTO',
  FUEL_INCOHERENT = 'FUEL_INCOHERENT',
  FUEL_OTHER = 'FUEL_OTHER',

  // Servicios complementarios
  WASH_NOT_DONE = 'WASH_NOT_DONE',
  CLEANING_INCOMPLETE = 'CLEANING_INCOMPLETE',
  BRIEFING_NOT_DONE = 'BRIEFING_NOT_DONE',
  SERVICE_NOT_PERFORMED = 'SERVICE_NOT_PERFORMED',
  ADDITIONAL_SERVICES_OTHER = 'ADDITIONAL_SERVICES_OTHER',

  // Exceso de kilómetros
  KM_EXCEEDED = 'KM_EXCEEDED',

  // Comportamiento / Imagen
  BAD_DRESSING = 'BAD_DRESSING',
  BAD_TREATMENT = 'BAD_TREATMENT',
  UNPROFESSIONAL = 'UNPROFESSIONAL',
  INAPPROPRIATE_COMMENTS = 'INAPPROPRIATE_COMMENTS',
  BEHAVIOR_OTHER = 'BEHAVIOR_OTHER',

  // Siniestro / Daños
  DAMAGE_EXTERNAL = 'DAMAGE_EXTERNAL',
  DAMAGE_INTERNAL = 'DAMAGE_INTERNAL',
  BROKEN_GLASS = 'BROKEN_GLASS',
  TIRE_PUNCTURE = 'TIRE_PUNCTURE',
  WRONG_FUEL = 'WRONG_FUEL',
  MISUSE = 'MISUSE',
  DAMAGE_OTHER = 'DAMAGE_OTHER',

  // Multa
  FINE_PARKING = 'FINE_PARKING',
  FINE_SPEED = 'FINE_SPEED',
  FINE_TOLL = 'FINE_TOLL',
  FINE_OTHER = 'FINE_OTHER',

  // Facturación
  BILL_FAKE_RECEIPT = 'BILL_FAKE_RECEIPT',
  BILL_OTHER = 'BILL_OTHER',

  // Proceso operativo
  OP_NO_RESPONSE = 'OP_NO_RESPONSE',
  OP_NO_COMMUNICATION = 'OP_NO_COMMUNICATION',
  OP_UNREPORTED_CHANGES = 'OP_UNREPORTED_CHANGES',
  OP_MISSION_NOT_CLOSED = 'OP_MISSION_NOT_CLOSED',
  OP_OTHER = 'OP_OTHER',

  // Fraude
  FRAUD_FAKE_JUSTIFICATION = 'FRAUD_FAKE_JUSTIFICATION',
  FRAUD_FAKE_DOCUMENT = 'FRAUD_FAKE_DOCUMENT',
  FRAUD_FAKE_BREAKDOWN = 'FRAUD_FAKE_BREAKDOWN',

  // Otros
  DRIVER_RECOGNITION = 'DRIVER_RECOGNITION',
  OTHER_GENERAL = 'OTHER_GENERAL',
}

export const adjustmentSubTypeDescriptions: Record<AdjustmentSubType, string> = {
  [AdjustmentSubType.DOC_NOT_SENT]: 'adjustmentSubType.DOC_NOT_SENT',
  [AdjustmentSubType.DOC_INCOMPLETE]: 'adjustmentSubType.DOC_INCOMPLETE',
  [AdjustmentSubType.DOC_INVALID]: 'adjustmentSubType.DOC_INVALID',
  [AdjustmentSubType.INVENTORY_INCOMPLETE]: 'adjustmentSubType.INVENTORY_INCOMPLETE',
  [AdjustmentSubType.SIGNATURE_MISSING]: 'adjustmentSubType.SIGNATURE_MISSING',
  [AdjustmentSubType.DOC_OTHER]: 'adjustmentSubType.DOC_OTHER',
  [AdjustmentSubType.PUNCTUALITY_DELAY]: 'adjustmentSubType.PUNCTUALITY_DELAY',
  [AdjustmentSubType.WRONG_LOCATION]: 'adjustmentSubType.WRONG_LOCATION',
  [AdjustmentSubType.PUBLIC_ROAD]: 'adjustmentSubType.PUBLIC_ROAD',
  [AdjustmentSubType.WRONG_PERSON]: 'adjustmentSubType.WRONG_PERSON',
  [AdjustmentSubType.UNAUTHORIZED_AREA]: 'adjustmentSubType.UNAUTHORIZED_AREA',
  [AdjustmentSubType.DELIVERY_INSTRUCTIONS_IGNORED]: 'adjustmentSubType.DELIVERY_INSTRUCTIONS_IGNORED',
  [AdjustmentSubType.EXTRA_DISTANCE]: 'adjustmentSubType.EXTRA_DISTANCE',
  [AdjustmentSubType.WRONG_DELIVERY_OTHER]: 'adjustmentSubType.WRONG_DELIVERY_OTHER',
  [AdjustmentSubType.FUEL_LOW_LEVEL]: 'adjustmentSubType.FUEL_LOW_LEVEL',
  [AdjustmentSubType.FUEL_NO_DASH_PHOTO]: 'adjustmentSubType.FUEL_NO_DASH_PHOTO',
  [AdjustmentSubType.FUEL_INCOHERENT]: 'adjustmentSubType.FUEL_INCOHERENT',
  [AdjustmentSubType.FUEL_OTHER]: 'adjustmentSubType.FUEL_OTHER',
  [AdjustmentSubType.WASH_NOT_DONE]: 'adjustmentSubType.WASH_NOT_DONE',
  [AdjustmentSubType.CLEANING_INCOMPLETE]: 'adjustmentSubType.CLEANING_INCOMPLETE',
  [AdjustmentSubType.BRIEFING_NOT_DONE]: 'adjustmentSubType.BRIEFING_NOT_DONE',
  [AdjustmentSubType.SERVICE_NOT_PERFORMED]: 'adjustmentSubType.SERVICE_NOT_PERFORMED',
  [AdjustmentSubType.ADDITIONAL_SERVICES_OTHER]: 'adjustmentSubType.ADDITIONAL_SERVICES_OTHER',
  [AdjustmentSubType.KM_EXCEEDED]: 'adjustmentSubType.KM_EXCEEDED',
  [AdjustmentSubType.BAD_DRESSING]: 'adjustmentSubType.BAD_DRESSING',
  [AdjustmentSubType.BAD_TREATMENT]: 'adjustmentSubType.BAD_TREATMENT',
  [AdjustmentSubType.UNPROFESSIONAL]: 'adjustmentSubType.UNPROFESSIONAL',
  [AdjustmentSubType.INAPPROPRIATE_COMMENTS]: 'adjustmentSubType.INAPPROPRIATE_COMMENTS',
  [AdjustmentSubType.BEHAVIOR_OTHER]: 'adjustmentSubType.BEHAVIOR_OTHER',
  [AdjustmentSubType.DAMAGE_EXTERNAL]: 'adjustmentSubType.DAMAGE_EXTERNAL',
  [AdjustmentSubType.DAMAGE_INTERNAL]: 'adjustmentSubType.DAMAGE_INTERNAL',
  [AdjustmentSubType.BROKEN_GLASS]: 'adjustmentSubType.BROKEN_GLASS',
  [AdjustmentSubType.TIRE_PUNCTURE]: 'adjustmentSubType.TIRE_PUNCTURE',
  [AdjustmentSubType.WRONG_FUEL]: 'adjustmentSubType.WRONG_FUEL',
  [AdjustmentSubType.MISUSE]: 'adjustmentSubType.MISUSE',
  [AdjustmentSubType.DAMAGE_OTHER]: 'adjustmentSubType.DAMAGE_OTHER',
  [AdjustmentSubType.FINE_PARKING]: 'adjustmentSubType.FINE_PARKING',
  [AdjustmentSubType.FINE_SPEED]: 'adjustmentSubType.FINE_SPEED',
  [AdjustmentSubType.FINE_TOLL]: 'adjustmentSubType.FINE_TOLL',
  [AdjustmentSubType.FINE_OTHER]: 'adjustmentSubType.FINE_OTHER',
  [AdjustmentSubType.BILL_FAKE_RECEIPT]: 'adjustmentSubType.BILL_FAKE_RECEIPT',
  [AdjustmentSubType.BILL_OTHER]: 'adjustmentSubType.BILL_OTHER',
  [AdjustmentSubType.OP_NO_RESPONSE]: 'adjustmentSubType.OP_NO_RESPONSE',
  [AdjustmentSubType.OP_NO_COMMUNICATION]: 'adjustmentSubType.OP_NO_COMMUNICATION',
  [AdjustmentSubType.OP_UNREPORTED_CHANGES]: 'adjustmentSubType.OP_UNREPORTED_CHANGES',
  [AdjustmentSubType.OP_MISSION_NOT_CLOSED]: 'adjustmentSubType.OP_MISSION_NOT_CLOSED',
  [AdjustmentSubType.OP_OTHER]: 'adjustmentSubType.OP_OTHER',
  [AdjustmentSubType.FRAUD_FAKE_JUSTIFICATION]: 'adjustmentSubType.FRAUD_FAKE_JUSTIFICATION',
  [AdjustmentSubType.FRAUD_FAKE_DOCUMENT]: 'adjustmentSubType.FRAUD_FAKE_DOCUMENT',
  [AdjustmentSubType.FRAUD_FAKE_BREAKDOWN]: 'adjustmentSubType.FRAUD_FAKE_BREAKDOWN',
  [AdjustmentSubType.DRIVER_RECOGNITION]: 'adjustmentSubType.DRIVER_RECOGNITION',
  [AdjustmentSubType.OTHER_GENERAL]: 'adjustmentSubType.OTHER_GENERAL',
};

export class AdjustmentReasonMapper {
  static readonly REASON_SUBTYPES: Record<AdjustmentReason, AdjustmentSubType[]> = {
    [AdjustmentReason.DOCUMENTATION_INVENTORY]: [
      AdjustmentSubType.DOC_NOT_SENT,
      AdjustmentSubType.DOC_INCOMPLETE,
      AdjustmentSubType.DOC_INVALID,
      AdjustmentSubType.INVENTORY_INCOMPLETE,
      AdjustmentSubType.SIGNATURE_MISSING,
      AdjustmentSubType.DOC_OTHER,
    ],
    [AdjustmentReason.PUNCTUALITY]: [
      AdjustmentSubType.PUNCTUALITY_DELAY,
    ],
    [AdjustmentReason.WRONG_DELIVERY]: [
      AdjustmentSubType.WRONG_LOCATION,
      AdjustmentSubType.PUBLIC_ROAD,
      AdjustmentSubType.WRONG_PERSON,
      AdjustmentSubType.UNAUTHORIZED_AREA,
      AdjustmentSubType.DELIVERY_INSTRUCTIONS_IGNORED,
      AdjustmentSubType.EXTRA_DISTANCE,
      AdjustmentSubType.WRONG_DELIVERY_OTHER,
    ],
    [AdjustmentReason.FUEL]: [
      AdjustmentSubType.FUEL_LOW_LEVEL,
      AdjustmentSubType.FUEL_NO_DASH_PHOTO,
      AdjustmentSubType.FUEL_INCOHERENT,
      AdjustmentSubType.FUEL_OTHER,
    ],
    [AdjustmentReason.ADDITIONAL_SERVICES]: [
      AdjustmentSubType.WASH_NOT_DONE,
      AdjustmentSubType.CLEANING_INCOMPLETE,
      AdjustmentSubType.BRIEFING_NOT_DONE,
      AdjustmentSubType.SERVICE_NOT_PERFORMED,
      AdjustmentSubType.ADDITIONAL_SERVICES_OTHER,
    ],
    [AdjustmentReason.EXCESS_KILOMETERS]: [
      AdjustmentSubType.KM_EXCEEDED,
    ],
    [AdjustmentReason.BEHAVIOR_APPEARANCE]: [
      AdjustmentSubType.BAD_DRESSING,
      AdjustmentSubType.BAD_TREATMENT,
      AdjustmentSubType.UNPROFESSIONAL,
      AdjustmentSubType.INAPPROPRIATE_COMMENTS,
      AdjustmentSubType.BEHAVIOR_OTHER,
    ],
    [AdjustmentReason.DAMAGES]: [
      AdjustmentSubType.DAMAGE_EXTERNAL,
      AdjustmentSubType.DAMAGE_INTERNAL,
      AdjustmentSubType.BROKEN_GLASS,
      AdjustmentSubType.TIRE_PUNCTURE,
      AdjustmentSubType.WRONG_FUEL,
      AdjustmentSubType.MISUSE,
      AdjustmentSubType.DAMAGE_OTHER,
    ],
    [AdjustmentReason.FINE]: [
      AdjustmentSubType.FINE_PARKING,
      AdjustmentSubType.FINE_SPEED,
      AdjustmentSubType.FINE_TOLL,
      AdjustmentSubType.FINE_OTHER,
    ],
/*     [AdjustmentReason.BILLING]: [
      AdjustmentSubType.BILL_FAKE_RECEIPT,
      AdjustmentSubType.BILL_OTHER,
    ], */
    [AdjustmentReason.OPERATIONS_PROCESS]: [
      AdjustmentSubType.OP_NO_RESPONSE,
      AdjustmentSubType.OP_NO_COMMUNICATION,
      AdjustmentSubType.OP_UNREPORTED_CHANGES,
      AdjustmentSubType.OP_MISSION_NOT_CLOSED,
      AdjustmentSubType.OP_OTHER,
    ],
    [AdjustmentReason.FRAUD]: [
      AdjustmentSubType.FRAUD_FAKE_JUSTIFICATION,
      AdjustmentSubType.FRAUD_FAKE_DOCUMENT,
      AdjustmentSubType.FRAUD_FAKE_BREAKDOWN,
    ],
    [AdjustmentReason.DRIVER_RECOGNITION]: [
      AdjustmentSubType.DRIVER_RECOGNITION,
    ],
    [AdjustmentReason.UNASSIGNATION]: [], // No tiene subtipos específicos definidos
    [AdjustmentReason.OTHER]: [
      AdjustmentSubType.OTHER_GENERAL,
    ],
  };
}

export interface AdjustmentActionType{
  default_message: string;
  amount: number | null;
  requires_quantity: boolean;
  canManual?: boolean;
  
}


export interface AdjustmentAction {
  quantity: 'quantity' | 'auto' | 'manual';
  price?: number;
}

type AdjustmentActionsTypesInterface = {
  [AdjustmentType.BONUS]: Partial<Record<AdjustmentReason, Partial<Record<AdjustmentSubType, AdjustmentAction>>>>;
  [AdjustmentType.PENALTY]: Partial<Record<AdjustmentReason, Partial<Record<AdjustmentSubType, AdjustmentAction>>>>;
};

export const AdjustmentActionsTypes: AdjustmentActionsTypesInterface = {

  // ─────────────────────────────────────────────
  // PENALTY — true = cálculo automático disponible
  //           false = importe manual obligatorio
  // ─────────────────────────────────────────────
  [AdjustmentType.PENALTY]: {
    [AdjustmentReason.DOCUMENTATION_INVENTORY]: {
      [AdjustmentSubType.DOC_NOT_SENT]:           { quantity: 'auto', price: 75 },   // 75 € fijo
      [AdjustmentSubType.DOC_INCOMPLETE]:          { quantity: 'auto', price: 75 },   // 75 € fijo
      [AdjustmentSubType.DOC_INVALID]:             { quantity: 'auto', price: 75 },   // 75 € fijo
      [AdjustmentSubType.INVENTORY_INCOMPLETE]:    { quantity: 'auto', price: 30 },   // 30 € fijo
      [AdjustmentSubType.SIGNATURE_MISSING]:       { quantity: 'auto', price: 30 },   // 30 € fijo
      [AdjustmentSubType.DOC_OTHER]:               { quantity: 'manual' },            // manual
    },

    [AdjustmentReason.PUNCTUALITY]: {
      [AdjustmentSubType.PUNCTUALITY_DELAY]:       { quantity: 'quantity' },          // 30/75/130 € según horas
    },

    [AdjustmentReason.WRONG_DELIVERY]: {
      [AdjustmentSubType.WRONG_LOCATION]:                  { quantity: 'auto', price: 100 },  // 100 € fijo
      [AdjustmentSubType.PUBLIC_ROAD]:                     { quantity: 'auto', price: 100 },  // 100 € fijo
      [AdjustmentSubType.WRONG_PERSON]:                    { quantity: 'auto', price: 100 },  // 100 € fijo
      [AdjustmentSubType.UNAUTHORIZED_AREA]:               { quantity: 'auto', price: 100 },  // 100 € fijo
      [AdjustmentSubType.DELIVERY_INSTRUCTIONS_IGNORED]:   { quantity: 'manual' },            // manual
      [AdjustmentSubType.EXTRA_DISTANCE]:                  { quantity: 'quantity' },          // 5 €/km (mín. 25 €)
      [AdjustmentSubType.WRONG_DELIVERY_OTHER]:            { quantity: 'manual' },            // manual
    },

    [AdjustmentReason.FUEL]: {
      [AdjustmentSubType.FUEL_LOW_LEVEL]:          { quantity: 'quantity' },          // 2 €/litro
      [AdjustmentSubType.FUEL_NO_DASH_PHOTO]:      { quantity: 'auto', price: 20 },   // 20 € fijo
      [AdjustmentSubType.FUEL_INCOHERENT]:         { quantity: 'manual' },            // manual
      [AdjustmentSubType.FUEL_OTHER]:              { quantity: 'manual' },            // manual
    },

    [AdjustmentReason.ADDITIONAL_SERVICES]: {
      [AdjustmentSubType.WASH_NOT_DONE]:               { quantity: 'manual' },            // manual
      [AdjustmentSubType.CLEANING_INCOMPLETE]:          { quantity: 'manual' },            // manual
      [AdjustmentSubType.BRIEFING_NOT_DONE]:            { quantity: 'manual' },            // manual
      [AdjustmentSubType.SERVICE_NOT_PERFORMED]:        { quantity: 'manual' },            // manual
      [AdjustmentSubType.ADDITIONAL_SERVICES_OTHER]:    { quantity: 'manual' },            // manual
    },

    [AdjustmentReason.EXCESS_KILOMETERS]: {
      [AdjustmentSubType.KM_EXCEEDED]:             { quantity: 'quantity' },          // 0,50 €/km
    },

    [AdjustmentReason.BEHAVIOR_APPEARANCE]: {
      [AdjustmentSubType.BAD_DRESSING]:            { quantity: 'auto', price: 15 },   // 15 € fijo
      [AdjustmentSubType.BAD_TREATMENT]:           { quantity: 'auto', price: 75 },   // 75 € fijo
      [AdjustmentSubType.UNPROFESSIONAL]:          { quantity: 'auto', price: 75 },   // 75 € fijo
      [AdjustmentSubType.INAPPROPRIATE_COMMENTS]:  { quantity: 'auto', price: 75 },   // 75 € fijo
      [AdjustmentSubType.BEHAVIOR_OTHER]:          { quantity: 'manual' },            // manual
    },

    [AdjustmentReason.DAMAGES]: {
      [AdjustmentSubType.DAMAGE_EXTERNAL]:         { quantity: 'auto', price: 30 },   // 30 € fijo
      [AdjustmentSubType.DAMAGE_INTERNAL]:         { quantity: 'auto', price: 30 },   // 30 € fijo
      [AdjustmentSubType.BROKEN_GLASS]:            { quantity: 'auto', price: 30 },   // 30 € fijo
      [AdjustmentSubType.TIRE_PUNCTURE]:           { quantity: 'auto', price: 30 },   // 30 € fijo
      [AdjustmentSubType.WRONG_FUEL]:              { quantity: 'auto', price: 30 },   // 30 € fijo
      [AdjustmentSubType.MISUSE]:                  { quantity: 'auto', price: 30 },   // 30 € fijo
      [AdjustmentSubType.DAMAGE_OTHER]:            { quantity: 'auto', price: 30 },   // 30 € fijo
    },

    [AdjustmentReason.FINE]: { // TODO sin cantidad
      [AdjustmentSubType.FINE_PARKING]:            { quantity: 'auto', price: 20 },   // 20 € fijo
      [AdjustmentSubType.FINE_SPEED]:              { quantity: 'auto', price: 20 },   // 20 € fijo
      [AdjustmentSubType.FINE_TOLL]:               { quantity: 'auto', price: 20 },   // 20 € fijo
      [AdjustmentSubType.FINE_OTHER]:              { quantity: 'auto', price: 20 },   // 20 € fijo
    },

    // ⚠️ Solo visible para admin, no panel cliente
/*     [AdjustmentReason.BILLING]: {
      [AdjustmentSubType.BILL_FAKE_RECEIPT]:       { quantity: 'manual' },            // manual
      [AdjustmentSubType.BILL_OTHER]:              { quantity: 'manual' },            // manual
    },
 */
    // ⚠️ Solo visible para admin, no panel cliente
    [AdjustmentReason.OPERATIONS_PROCESS]: {
      [AdjustmentSubType.OP_NO_RESPONSE]:          { quantity: 'auto', price: 25 },   // 25 € fijo
      [AdjustmentSubType.OP_NO_COMMUNICATION]:     { quantity: 'auto', price: 25 },   // 25 € fijo
      [AdjustmentSubType.OP_UNREPORTED_CHANGES]:   { quantity: 'manual' },            // manual
      [AdjustmentSubType.OP_MISSION_NOT_CLOSED]:   { quantity: 'quantity' },          // 30 € si <6h / especial >72h
      [AdjustmentSubType.OP_OTHER]:                { quantity: 'manual' },            // manual
    },

    // ⚠️ Solo visible para admin, no panel cliente
    [AdjustmentReason.FRAUD]: {
      [AdjustmentSubType.FRAUD_FAKE_JUSTIFICATION]: { quantity: 'auto', price: 200 },  // 200 € fijo
      [AdjustmentSubType.FRAUD_FAKE_DOCUMENT]:      { quantity: 'auto', price: 200 },  // 200 € fijo
      [AdjustmentSubType.FRAUD_FAKE_BREAKDOWN]:     { quantity: 'auto', price: 75 },   // 75 € fijo
    },

    [AdjustmentReason.UNASSIGNATION]: {},  // sin sub_reason, importe siempre manual

    [AdjustmentReason.OTHER]: {
      // manual
    },
  },

  // ─────────────────────────────────────────────
  // BONUS — solo razones aplicables a bonificaciones
  // ─────────────────────────────────────────────
  [AdjustmentType.BONUS]: {
    [AdjustmentReason.DRIVER_RECOGNITION]: {
    
    },

    [AdjustmentReason.UNASSIGNATION]: {},  // sin sub_reason, importe siempre manual

    [AdjustmentReason.OTHER]: {
    
    },
  },
};
  export const statusColors: Record<string, { bg: string; text: string }> = {
    'NEW': { bg: '#419AE2', text: '#FFFFFF' },
    'PENDING_DRIVER': { bg: '#FFF650', text: '#000000' },
    'PENDING_CLIENT': { bg: '#E68A00', text: '#FFFFFF' },
    'PENDING_END_CUSTOMER': { bg: '#D47B00', text: '#FFFFFF' },
    'PENDING_INTERNAL_COLLABORATOR': { bg: '#9C6ADE', text: '#FFFFFF' },
    'PENDING_WORKSHOP': { bg: '#868686', text: '#FFFFFF' },
    'PENDING_INSURANCE': { bg: '#204D7C', text: '#FFFFFF' },
    'FINISHED': { bg: '#7AD33B', text: '#000000' }
  };